<template>
    <div class="example-modal-content popupJia" :class="{'popupJiaPC':$store.state.innerWidth>768}">
        
            <div id="dire" style="word-break: normal !important;">
                <div class="dire-contain row">
                    <div class="dire-1320px">
                        <div class="dire-all dire-title-hk">
                                抱歉，本網頁不支援您目前的瀏覽器
                            </div>
                            <div class="dire-all dire-title-en">
                                Sorry, your current browser is not supported by our website
                        </div>
                        <div class="dire-all dire-inner-hk">
                            為求最佳的瀏覽效果，我們採用較新的程式編寫技術。要查看此內容，請使用以下瀏覽器
                        </div>
                        <div class="dire-all dire-inner-en">
                            We adopt the latest programming technologies for the best viewing experience. To view this content, please use one of the following browsers
                        </div>
                        <div class="dire-all dire-inner-broser "> 
                            <div class="dire-edge dire-broser">
                                <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_Blank">
                                    <div class="dire-edge-img dire-broser-img" >
                                        <img :src="edge" alt="" />
                                    </div>
                                    <div class="dire-safari-img-bottom">
                                        Microsoft Edge 
                                    </div>
                                </a>
                            </div>
                            <div class="dire-chrome dire-broser">
                                <a href="http://www.google.com/chrome/" target="_Blank" >
                                    <div class="dire-chrome-img dire-broser-img">
                                        <img :src="chrome" alt="" />
                                    </div>
                                  
                                    <div class="dire-safari-img-bottom">
                                        Google Chrome
                                    </div>
                                   
                                </a>
                            </div>
                            <div class="dire-firefox dire-broser">
                                <a href="http://www.firefox.com" target="_Blank">
                                    <div class="dire-firefox-img dire-broser-img">
                                        <img :src="firefox" alt="" />
                                    </div>
                                    <div class="dire-safari-img-bottom">
                                        Mozilla Firefox
                                    </div>
                                </a>
                            </div>
                            <div class="dire-safari dire-broser">
                                <a href="https://support.apple.com/downloads/#safari" target="_Blank">
                                    <div class="dire-safari-img dire-broser-img">
                                        <img :src="safari" alt="" />
                                    </div>
                                    <div class="dire-safari-img-bottom">
                                        Safari 
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>


export default {
    props: ['text', 'title'],
    methods: {
        closeByEvent() {
            this.$emit('close');
        }
    },
    created() {
        var that = this;
        this.edge = require('@/images/logo-edge.png');
        this.chrome = require('@/images/logo-chrome.png');
        this.firefox = require('@/images/logo-firefox.png');
        this.safari = require('@/images/logo-safari.png');
    }
}
</script>

<style type="text/css">
    #modals-container{
             z-index:999999
    }
    .v--modal-background-click{
      
    }
	.v--modal-overlay{
            background: rgba(0, 0, 0, 0.8) !important;
         
    }
    .popupJia{
        padding: 40px;
    }
    .departmentJia{
        display: flex;
        flex-direction: column;
     
    }
    .popupTitleJia{
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        
    }
    .popup-a{
        color: rgb(34,34,93);

        padding-bottom: 1px;
    }
    .popup-link{
      
        display: inline-block;
        /* border-bottom: 1px solid rgba(0, 0, 0, 0.8);*/
        margin-bottom: 12px;
        margin-top: 26px; 
    }
    .i-closeJia{
        color: rgb(34,34,93);
        font-size: 26px;
        margin-top: 5px;
    }
</style>